import React, { ReactElement } from 'react'
import { Card, Text } from 'elements'

type Props = {
  value: ReactElement
  text: string
}

export default function TextCard(props: Props) {
  const { value, text } = props

  return (
    <Card
      width="365px"
      height="265px"
      flexDirection="column"
      py="gigantic"
      justifyContent="space-evenly"
      alignItems="center"
    >
      <Text fontSize="gigantic" fontWeight="bold">
        {value}
      </Text>
      <Text fontSize="xlarge">{text}</Text>
    </Card>
  )
}
